import {FlatArea} from './flat-area.model';

export class Flat {
  id?: number;
  name?: string = '';
  size?: number = 0;
  price?: number = 0;
  images?: string[];
  coverImageUrl?: string;
  level?: number;
  flatAreas?: FlatArea[] = [];
  numberOfRooms?: number;
  project?: string;
  coordinateX?: number;
  coordinateY?: number;
  latitude?: number;
  longitude?: number;
  side?: string;
  imageUrlForCoordinate: string;
  concat?: boolean;
  concatIds?: number[];
  concatImageUrl?: string;
  garden?: number;
  soldOut?: boolean;
  reserved?: boolean;
  updatedAt?: number;
  createdAt?: number;
  isOffice?: boolean;

  layoutImageUrlFilePath?: string;
  layoutImageUrl?: string;

  salesImageUrlFilePath?: string;
  salesImageUrl?: string;

  buildingInImageUrlFilePath?: string;
  buildingInImageUrl?: string;

}
